import { render } from "./TiktokQuery.vue?vue&type=template&id=768c39d0&scoped=true"
import script from "./TiktokQuery.vue?vue&type=script&lang=js"
export * from "./TiktokQuery.vue?vue&type=script&lang=js"

import "./TiktokQuery.vue?vue&type=style&index=0&id=768c39d0&scoped=true&lang=css"
import "./TiktokQuery.vue?vue&type=style&index=1&id=768c39d0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768c39d0"]])

export default __exports__